<gtw-confirmation-modal
  [config]="modalConfig"
  [visible]="false"
  (confirmed)="confirmDelete()"
  (cancelled)="cancel()"
  (closed)="cancel()">
</gtw-confirmation-modal>
